import React, {ReactNode, useRef} from "react";
import {styled, ThinScrollbar} from "@reside/ui";
import {DashboardBoardScrollMinimap} from "../../../atoms/dashboard-table/DashboardBoardScrollMinimap";
import {
  ListTableBleed,
  ListTableScrollInner,
  ListTableScrollShell,
} from "../styles";

const ListTableScrollAreaBase = styled(ThinScrollbar)`
  overflow-x: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  /* Chromium/Safari: hide native horizontal scrollbar; minimap replaces it. */
  &::-webkit-scrollbar:horizontal {
    height: 0;
  }
`;

const ListTableScrollArea = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof ThinScrollbar>
>((props, ref) => <ListTableScrollAreaBase ref={ref} {...props} />);

ListTableScrollArea.displayName = "ListTableScrollArea";

type Props = Readonly<{
  children: ReactNode;
  /** Visual tick count on the minimap (not tied to actual column count). */
  minimapTicks: number;
}>;

export const HubAndSpokeListTableScroll = ({children, minimapTicks}: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <ListTableBleed>
      <ListTableScrollShell>
        <ListTableScrollArea ref={scrollRef}>
          <ListTableScrollInner>{children}</ListTableScrollInner>
        </ListTableScrollArea>
        <DashboardBoardScrollMinimap
          scrollRef={scrollRef}
          columnCount={minimapTicks}
          tickLayout="horizontal"
          pinToViewport
        />
      </ListTableScrollShell>
    </ListTableBleed>
  );
};
